import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { AmChartsModule } from '@amcharts/amcharts3-angular/es2015';
import { RouterModule } from '@angular/router';

import './shared/rxjs-operators';
import { RemoteService } from './services/remote.service';
import { DynamicDialogService } from './services/dynamic-dialog.service';
import { UIStorageService } from './services/storage.service';
import { Config } from './services/config.service';
import { AppStartupService } from './services/app-startup';
import { LocalCacheService } from './services/cache/local-cache.service';
import { CacheStorageService } from './services/cache/cache-storage.service';
import { IDBService } from './services/indexdb/idb.service';
import { AppUtility } from './utils/utility';
import { LoggingService } from './services/logging/logging.service';
import { LoggingConstants } from './constants/logging-constant';
import { LoggingStartupConfigService } from './services/logging/logging-startup';
import { DomStorageFallbackService } from './services/DomStorageFallback.service';
import { GenericService } from './services/generic.service';
import { CommonAppService } from './services/commonApp.service';
import { DynamicComponentService } from './services/dynamic-component.service';
import { PageConstants } from './constants/page.constants';
import { BrandingService } from './services/branding.service';
import { LogFrontendError } from './services/logging/logFrontendError';
import { UISafePipe } from './pipes/uisafe.pipe';
import { ThriveCommonService } from './services/thrivecommon.service';
import { GoogleAnalyticsService } from './services/googleAnalytics.service';

import { TooltipModule } from './primeng_components/tooltip/tooltip';
import { SharedModule } from './primeng_components/common/shared';
import { DomHandler } from './primeng_components/dom/domhandler';
import { ButtonModule } from './primeng_components/button/button';
import { DialogModule } from './primeng_components/dialog/dialog';
import { AccordionModule } from './primeng_components/accordion/accordion';
import { DropdownModule } from './primeng_components/dropdown/dropdown';
import { InputTextareaModule } from './primeng_components/inputtextarea/inputtextarea';
import { CalendarModule } from './primeng_components/calendar/calendar';
import { InputTextModule } from './primeng_components/inputtext/inputtext';
import { CheckboxModule } from './primeng_components/checkbox/checkbox';
import { RadioButtonModule } from './primeng_components/radiobutton/radiobutton';
import { TabViewModule } from './primeng_components/tabview/tabview';
import { DataTableModule } from './primeng_components/datatable/datatable';
import { MultiSelectModule } from './primeng_components/multiselect/multiselect';
import { StepsModule } from './primeng_components/steps/steps';
import { AutoCompleteModule } from './primeng_components/autocomplete/autocomplete';
import { PaginatorModule } from './primeng_components/paginator/paginator';
import { TreeModule } from './primeng_components/tree/tree';
import { SelectItem } from './primeng_components/common/api';

export { TooltipModule } from './primeng_components/tooltip/tooltip';
export { SharedModule } from './primeng_components/common/shared';
export { DomHandler } from './primeng_components/dom/domhandler';
export { ButtonModule } from './primeng_components/button/button';
export { DialogModule } from './primeng_components/dialog/dialog';
export { AccordionModule } from './primeng_components/accordion/accordion';
export { DropdownModule } from './primeng_components/dropdown/dropdown';
export { InputTextareaModule } from './primeng_components/inputtextarea/inputtextarea';
export { CalendarModule } from './primeng_components/calendar/calendar';
export { InputTextModule } from './primeng_components/inputtext/inputtext';
export { CheckboxModule } from './primeng_components/checkbox/checkbox';
export { RadioButtonModule } from './primeng_components/radiobutton/radiobutton';
export { TabViewModule } from './primeng_components/tabview/tabview';
export { DataTableModule } from './primeng_components/datatable/datatable';
export { MultiSelectModule } from './primeng_components/multiselect/multiselect';
export { StepsModule } from './primeng_components/steps/steps';
export { AutoCompleteModule } from './primeng_components/autocomplete/autocomplete';
export { PaginatorModule } from './primeng_components/paginator/paginator';
export { TreeModule } from './primeng_components/tree/tree';
export { SelectItem } from './primeng_components/common/api';

import { AL_CORE_DIRECTIVES } from './directives/directives.index';
import { AL_CORE_COMPONENTS } from './components/components.index';
export { AL_CORE_COMPONENTS } from './components/components.index';
export { AL_CORE_DIRECTIVES } from './directives/directives.index';
export * from './components/components.index';
export { ThriveCommonService } from './services/thrivecommon.service';
export { DomStorageFallbackService } from './services/DomStorageFallback.service';
// export { ButtonModule } from 'primeng/primeng';
// export { DialogModule } from 'primeng/primeng';
// export { InputTextareaModule } from 'primeng/primeng';
// export { InputTextModule } from 'primeng/primeng';
// export { TooltipModule } from 'primeng/primeng';
// export { SharedModule } from 'primeng/primeng';
export * from './models/models.index';
export * from './pipes/pipes.index';
export * from './services/services.index';
export { AppUtility } from './utils/utility';
export { IDGenerator } from './utils/IDGenerator.utility';
export { LoggingConstants } from './constants/logging-constant';
export { PageConstants } from './constants/page.constants';
export { dynamicComponentConstants } from './constants/dynamicComponent-constant';
export * from './directives/directives.index';

// import { CustomValidators } from './primeng_components/ng2-validation/dist/index';
// export { CustomValidators } from './primeng_components/ng2-validation/dist/index';

export function configFactory() {
    return Config.getInstance('./al-assets/core.config.properties');
}

@NgModule({
    imports: [
        CommonModule,
        // BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        DialogModule,
        ButtonModule,
        InputTextareaModule,
        InputTextModule,
        TooltipModule,
        AccordionModule,
        DropdownModule,
        CalendarModule,
        CheckboxModule,
        RadioButtonModule,
        TabViewModule,
        MultiSelectModule,
        StepsModule,
        AutoCompleteModule,
        PaginatorModule,
        TreeModule,
        DataTableModule
    ],
    declarations: [
        UISafePipe,
        AL_CORE_DIRECTIVES,
        AL_CORE_COMPONENTS
    ],
    providers: [DomHandler],
    exports: [
        UISafePipe,
        AL_CORE_COMPONENTS,
        AL_CORE_DIRECTIVES,
        SharedModule,
        DialogModule,
        ButtonModule,
        InputTextareaModule,
        InputTextModule,
        TooltipModule,
        AccordionModule,
        DropdownModule,
        CalendarModule,
        CheckboxModule,
        RadioButtonModule,
        TabViewModule,
        MultiSelectModule,
        StepsModule,
        AutoCompleteModule,
        PaginatorModule,
        TreeModule,
        DataTableModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AlCoreModuleLibrary {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AlCoreModuleLibrary,
            providers: [
                {
                    provide: 'Config',
                    useFactory: configFactory
                },
                RemoteService,
                LoggingService,
                UIStorageService,
                CookieService,
                LocalCacheService,
                CacheStorageService,
                AppStartupService,
                IDBService,
                AppUtility,
                LoggingStartupConfigService,
                DomStorageFallbackService,
                GenericService,
                DynamicComponentService,
                BrandingService,
                GoogleAnalyticsService,
                DynamicDialogService,
                ThriveCommonService,
                CommonAppService,
                LogFrontendError
            ]
        };
    }

    ngDoBootstrap() { }

}
